import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  fetchMediaListAction,
  fetchMediaItemAction,
  clearLastErrorAction,
} from '../../store/mediaBrowser/mediaBrowserReducers';

import bottle from './bottle';

// eslint-disable-next-line prefer-destructuring
const MediaBrowserContainer = bottle().container.MediaBrowserContainer;

const mapStateToProps = state => ({
  progress: state.mediaBrowser.progress,
  allMedia: state.mediaBrowser.allMedia,
  mediaId: state.mediaBrowser.mediaId,
  bearerToken: state.mediaBrowser.bearerToken,
  lastError: state.mediaBrowser.lastError,
  loading: state.mediaBrowser.loading,
});

const mapDispatchToProps = dispatch => ({
  fetchMediaList: () => {
    dispatch(fetchMediaListAction());
  },
  fetchMediaItem: (mediaId) => {
    dispatch(fetchMediaItemAction(mediaId));
  },
  clearLastError: () => dispatch(clearLastErrorAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(MediaBrowserContainer));
